"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getITSMConnection = exports.updateITSMConnection = exports.addITSMConnection = exports.fetchAllConnectionsTemplates = exports.validateFilter = exports.fetchConnectionsTemplates = exports.deleteITSMConnection = exports.fetchITSMConnectionsList = void 0;

var _apiService = _interopRequireDefault(require("../utils/api-service"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var fetchITSMConnectionsList = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _apiService.default.get('/api/itsm-manager/connections');

          case 2:
            response = _context.sent;
            return _context.abrupt("return", response.data);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchITSMConnectionsList() {
    return _ref.apply(this, arguments);
  };
}();

exports.fetchITSMConnectionsList = fetchITSMConnectionsList;

var deleteITSMConnection = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(connectionId) {
    var response;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _apiService.default.delete("/api/itsm-manager/connections/".concat(connectionId));

          case 2:
            response = _context2.sent;
            return _context2.abrupt("return", response.data);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function deleteITSMConnection(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.deleteITSMConnection = deleteITSMConnection;

var fetchConnectionsTemplates = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(type) {
    var response;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _apiService.default.get("/api/itsm-manager/connection-templates/".concat(type));

          case 2:
            response = _context3.sent;
            return _context3.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function fetchConnectionsTemplates(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

exports.fetchConnectionsTemplates = fetchConnectionsTemplates;

var validateFilter = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(reqBody) {
    var response;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _apiService.default.post('/api/itsm-integration/filter-validation', reqBody);

          case 2:
            response = _context4.sent;
            return _context4.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function validateFilter(_x3) {
    return _ref4.apply(this, arguments);
  };
}();

exports.validateFilter = validateFilter;

var fetchAllConnectionsTemplates = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
    var response;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _apiService.default.get("/api/itsm-manager/connection-templates");

          case 2:
            response = _context5.sent;
            return _context5.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

          case 4:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function fetchAllConnectionsTemplates() {
    return _ref5.apply(this, arguments);
  };
}();

exports.fetchAllConnectionsTemplates = fetchAllConnectionsTemplates;

var addITSMConnection = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(data) {
    var response;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return _apiService.default.post('/api/itsm-manager/connections', data);

          case 2:
            response = _context6.sent;
            return _context6.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

          case 4:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function addITSMConnection(_x4) {
    return _ref6.apply(this, arguments);
  };
}();

exports.addITSMConnection = addITSMConnection;

var updateITSMConnection = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(_ref7) {
    var connectionId, data, response;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            connectionId = _ref7.connectionId, data = _ref7.data;
            _context7.next = 3;
            return _apiService.default.patch("/api/itsm-manager/connections/".concat(connectionId), data);

          case 3:
            response = _context7.sent;
            return _context7.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

          case 5:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function updateITSMConnection(_x5) {
    return _ref8.apply(this, arguments);
  };
}();

exports.updateITSMConnection = updateITSMConnection;

var getITSMConnection = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(connectionId) {
    var response;
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return _apiService.default.get("/api/itsm-manager/connections/".concat(connectionId));

          case 2:
            response = _context8.sent;
            return _context8.abrupt("return", response === null || response === void 0 ? void 0 : response.data);

          case 4:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function getITSMConnection(_x6) {
    return _ref9.apply(this, arguments);
  };
}();

exports.getITSMConnection = getITSMConnection;